(() => {
  /*
   * Benefit story: each benefit writes itself in, word by word, the first time it scrolls into view.
   * One IntersectionObserver adds a class; the words' staggered CSS transitions do the rest,
   * so nothing runs while the page scrolls.
   */
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  const setup = (section) => {
    if (section.dataset.bstoryReady) return;
    section.dataset.bstoryReady = '';
    const items = [...section.querySelectorAll('[data-bstory-item]')];
    const counter = section.querySelector('[data-bstory-current]');
    if (!items.length) return;

    items.forEach((item) => {
      item.querySelectorAll('.glow-bstory__w').forEach((word, index) => {
        word.style.transitionDelay = `${Math.min(index * 0.045, 1.2).toFixed(3)}s`;
      });
    });
    section.classList.add('is-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const item = entry.target;
          item.classList.add('is-written');
          observer.unobserve(item);
          items.forEach((other) => other.classList.toggle('is-active', other === item));
          if (counter) counter.textContent = String(items.indexOf(item) + 1).padStart(2, '0');
        });
      },
      { rootMargin: '0px 0px -30% 0px', threshold: 0.2 }
    );
    items.forEach((item) => observer.observe(item));
  };

  const init = (scope = document) => {
    if (designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    scope.querySelectorAll('[data-glow-bstory]').forEach(setup);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
